import { defaultVersion, defaultFilterSgaVersions } from "./state";

/**
 * Mutación que lista las versiones de SGA .
 *
 * @param {*} state.versionsSga - Estado de las versiones de SGA.
 * @param versionsSga - Versiones de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setVersionsSga(state, versionsSga) {
    state.versionsSga = versionsSga;
}

/**
 * Mutación que establece la acción a realizar.
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar.
 * @return {void}
 * @author Brandon Torres
 */
export function setActionSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la versión por defecto.
 *
 * @param {*} state.version - Estado de la versión.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultVersionSga(state) {
    state.version = defaultVersion();
}

/**
 * Mutación que establece el filtro de versiones de SGA por defecto.
 *
 * @param {*} state.filterVersionsSga - Estado del filtro de versiones de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSgaVersions(state) {
    state.filterVersionsSga = defaultFilterSgaVersions();
}

/**
 * Mutación que establece la cantidad de versiones por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterVersionsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterVersionsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterVersionsSga = {
        ...state.filterVersionsSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterVersionsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterVersionsSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de versiones.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterVersionsSga.page - Página actual.
 * @param {*} state.filterVersionsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterVersionsSga.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateVersionsSga(state, paginate) {
    state.filterVersionsSga = {
        ...state.filterVersionsSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la versión de SGA.
 *
 * @param {*} state.version - Estado de la versión.
 * @param version - Versión de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setVersionSga(state, version) {
    let ids = version.sga_sub_not_danger_versions.length ? version.sga_sub_not_danger_versions.map(item => item.id) : [];
    state.version = {
        id: version.id,
        version: String(version.version),
        date_of_publication: version.date_of_publication,
        subs_not_dangers: ids
    };
}

/**
 * Mutación que establece la fecha de publicación de la versión de SGA.
 *
 * @param {*} state.filterVersionsSga - Estado del filtro de versiones de SGA.
 * @param date_of_publication - Fecha de publicación de la versión de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDateOfPublicationSga(state, date_of_publication) {
    state.filterVersionsSga.date_of_publication_from = date_of_publication[0];
    state.filterVersionsSga.date_of_publication_to = date_of_publication[1];
}

/**
 * Mutación que establece las versiones activas de SGA.
 *
 * @param {*} state.activeVersions - Estado de versiones activas de SGA.
 * @param activeVersions - Versiones activas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveVersionsSga(state, activeVersions) {
    state.activeVersions = activeVersions;
}

/**
 * Mutación que establece las frases no peligrosas de SGA.
 *
 * @param subsNotDangers - Lista de frases no peligrosas de SGA.
 * @return {void}
 * @author Paul Valencia.
 */
export function setSubsNotDangers(state, subsNotDangers) {
    state.subsNotDangers = subsNotDangers
}
